import { render } from "./JuntaPicker.vue?vue&type=template&id=4c73493d&scoped=true"
import script from "./JuntaPicker.vue?vue&type=script&lang=ts"
export * from "./JuntaPicker.vue?vue&type=script&lang=ts"

import "./JuntaPicker.vue?vue&type=style&index=0&id=4c73493d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c73493d"

export default script